import moment from 'moment-business-days'

moment.locale('fr')

export {moment}
